<template>
  <div class="container">
    <div class="inside-banner">
      <!-- ElementUI轮播图 -->
      <el-carousel
          class="banner-carousel"
          indicator-position="none"
          loop
          autoplay
          arrow="never"
      >
        <el-carousel-item v-for="(item, index) in bannerImgList" :key="index">
          <img
              :src="item.src"
              :alt="item.title || '使用维护轮播图'"
              class="carousel-img"
          />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="service-content">
      <div class="service-nav">
        <a href="/portal_check?type=check" target="_blank">真伪查询</a>
        <a href="/portal_check?type=sales" target="_blank">售后流程</a>
        <a href="/portal_check?type=question" target="_blank">常见问题</a>
        <a class="on" target="_self">使用维护</a>
      </div>
      <div class="service-box service-wh">
        <ul v-if="bottomImgList.length >= 5"> <!-- 确保图片列表数量足够 -->
          <li>
            <a href=""><img :src="bottomImgList[0].src" alt="使用维护封面"></a>
          </li>
          <li>
            <div>
              <h3>球台使用维护</h3>
              <a @click="handNewsList('47')" target="_blank">查看详情</a>
            </div>
            <p>
              <a href=""><img :src="bottomImgList[1].src" alt="球台使用维护"></a>
            </p>
          </li>
          <li>
            <p>
              <a href=""><img :src="bottomImgList[2].src" alt="球杆使用维护"></a>
            </p>
            <div>
              <h3>球杆使用维护</h3>
              <a @click="handNewsList('48')" target="_blank">查看详情</a>
            </div>
          </li>
          <li>
            <p>
              <a href=""><img :src="bottomImgList[3].src" alt="使用维护说明1"></a>
            </p>
            <p>
              <a href=""><img :src="bottomImgList[4].src" alt="使用维护说明2"></a>
            </p>
          </li>
        </ul>
        <!-- 图片列表不足时的兜底提示 -->
        <div v-else class="empty-tip">
          暂无使用维护相关图片
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getImgList} from "@/api/home";
import {ImageTypeEnum} from "@/enums/imageTypeEnum";
import {NodeIdEnum} from "@/enums/nodeIdEnum";

export default {
  data() {
    return {
      bannerImgList: [],
      bottomImgList: [],
      loading: false // 补充loading初始化，避免控制台警告
    }
  },
  created() {
    this.getBannerList();
  },
  methods: {
    //获取图片
    async getBannerList() {
      try {
        this.loading = true;

        const typeStr = `${ImageTypeEnum.CHECK_35_BANNER.value},${ImageTypeEnum.CHECK_39_BANNER.value}`;

        const res = await getImgList(typeStr);
        const dataList = res.data || [];
        this.bannerImgList = dataList.filter(item => item.classify === ImageTypeEnum.CHECK_35_BANNER.value && item.src);
        this.bottomImgList = dataList.filter(item => item.classify === ImageTypeEnum.CHECK_39_BANNER.value && item.src);
      } catch (error) {
        console.error("获取轮播图/使用维护图片失败：", error);
        this.$message?.error("图片加载失败，请稍后重试");
      } finally {
        this.loading = false;
      }
    },
    //相关新闻点击事件
    handNewsList(id){
      this.$router.push({ path: '/article', query: { articleId: id, type:NodeIdEnum.ARTICLE_TYPE_SYWH_ID.value } });
    },
  },
}
</script>

<style scoped lang="scss">
.container {
  position: relative;
  width: 100%;
  max-width: 1920px; // 限制最大宽度，避免大屏拉伸
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0 15px; // 移动端增加左右内边距，防止内容贴边
}

// Banner容器
.inside-banner {
  position: relative;
  margin-top: 100px;
  width: 100%;
  overflow: hidden;

  // 平板适配 (768px以下)
  @media (max-width: 768px) {
    margin-top: 80px;
  }
  // 手机适配 (480px以下)
  @media (max-width: 480px) {
    margin-top: 60px;
  }
}

// ElementUI轮播图容器样式
.banner-carousel {
  width: 100%;
  height: 880px !important;

  // 平板适配
  @media (max-width: 768px) {
    height: 400px !important; // 优化平板端高度，视觉更协调
  }
  // 手机适配（使用vw单位，适配不同屏幕宽度）
  @media (max-width: 480px) {
    height: 50vw !important;
    max-height: 300px; // 限制最大高度，避免小屏过高
  }

  :deep(.el-carousel__container) {
    height: 100%;
  }

  :deep(.el-carousel-item) {
    height: 100%;
  }
}

// 轮播图图片样式
.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  // 移动端优化图片显示
  @media (max-width: 480px) {
    object-fit: contain;
    background: #f5f5f5;
  }
}

.service-nav {
  text-align: center;
  background: #fff;
  padding: 0 10px; // 增加内边距，防止按钮贴边
  box-sizing: border-box;

  // 平板适配
  @media (max-width: 768px) {
    padding: 0 5px;
  }

  // 手机适配
  @media (max-width: 480px) {
    padding: 0;
  }

  a, span {
    color: #222;
    display: inline-block;
    vertical-align: top;
    width: 12%;
    height: 50px;
    margin: 50px 1%;
    text-align: center;
    line-height: 48px;
    font-size: 18px;
    border: 1px solid #666;
    cursor: pointer;
    border-radius: 6px;
    box-sizing: border-box; // 确保边框不影响宽度计算
    text-decoration: none; // 去除链接下划线

    // 平板适配
    @media (max-width: 768px) {
      width: 22%; // 调整宽度，适配平板
      margin: 30px 1%;
      height: 45px;
      line-height: 43px;
      font-size: 16px;
    }

    // 手机适配
    @media (max-width: 480px) {
      width: 46%; // 改为两行显示，提升触控体验
      margin: 15px 2%;
      height: 40px;
      line-height: 38px;
      font-size: 14px;
    }
  }

  .on {
    background: #d26b6b;
    color: #fff;
    border-color: #d26b6b;
  }
}

.service-nav-fixed {
  z-index: 666;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  max-width: none;
  box-shadow: 0 0 8px rgba(0,0,0,.1);
  padding: 0 10px; // 增加内边距

  a, span {
    height: 36px;
    line-height: 36px;
    margin: 15px 1%;
    font-size: 16px;

    // 手机适配
    @media (max-width: 480px) {
      height: 32px;
      line-height: 30px;
      margin: 10px 2%;
      font-size: 13px;
    }
  }
}

.service-box {
  padding: 50px 0;
  background: #f6f6f6;
  max-width: 1600px;
  margin: 0 auto;
  box-sizing: border-box;

  // 平板适配
  @media (max-width: 768px) {
    padding: 30px 0;
  }

  // 手机适配
  @media (max-width: 480px) {
    padding: 20px 0;
  }
}

// 核心：使用维护区域适配
.service-wh {
  position: relative;
  height: 0;
  padding-top: 25%; // 保持宽高比
  width: 100%;
  box-sizing: border-box;

  // 平板适配 - 调整宽高比
  @media (max-width: 768px) {
    padding-top: 50%; // 两列布局，高度翻倍
  }

  // 手机适配 - 调整宽高比
  @media (max-width: 480px) {
    padding-top: 100%; // 一列布局，高度再次调整
    margin: 0 10px;
  }

  // 图片不足时的兜底提示
  .empty-tip {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 18px;
    color: #666;
    text-align: center;

    @media (max-width: 480px) {
      font-size: 14px;
    }
  }

  ul {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding: 0; // 重置ul默认内边距
    margin: 0; // 重置ul默认外边距

    li {
      position: relative;
      float: left;
      width: 25%;
      height: 100%;
      text-align: center;
      overflow: hidden;
      background: #fcd54c;
      box-sizing: border-box;

      // 平板适配 - 改为2列布局
      @media (max-width: 768px) {
        width: 50%;
        height: 50%;
      }

      // 手机适配 - 改为1列布局
      @media (max-width: 480px) {
        width: 50%;
        height: 50%;
      }

      // 第三个li的背景色
      &:nth-of-type(3) {
        background: #54a4cd;

        // 手机适配 - 调整背景色显示
        @media (max-width: 480px) {
          background: #54a4cd;
        }
      }

      p {
        height: 50%;
        overflow: hidden;
        margin: 0; // 重置p默认外边距

        // 手机适配
        @media (max-width: 480px) {
          height: 50%;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover; // 保持图片比例

          // 手机适配
          //@media (max-width: 480px) {
          //  object-fit: contain;
          //}
        }
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;

        // 手机适配
        //@media (max-width: 480px) {
        //  object-fit: contain;
        //}
      }

      h3 {
        width: 100%;
        padding: 0 10px;
        font-size: 36px;
        color: #fff;
        font-weight: normal;
        margin: 0 0 10px 0; // 重置margin并调整

        // 平板适配
        @media (max-width: 768px) {
          font-size: 24px;
        }

        // 手机适配
        @media (max-width: 480px) {
          font-size: 16px;
          padding: 0 5px;
        }
      }

      // 第一个li的伪元素（保留但优化）
      &:first-child::before {
        position: absolute;
        content: '';
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }

      a h3 {
        z-index: 11;
        position: absolute;
        bottom: 8%;

        // 手机适配
        @media (max-width: 480px) {
          bottom: 5%;
          font-size: 14px;
        }
      }

      div {
        position: relative;
        height: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        // 手机适配
        @media (max-width: 480px) {
          height: 50%;
          justify-content: center;
          padding: 10px 0;
        }

        // 偶数li的箭头装饰
        &::after {
          position: absolute;
          content: '';
          bottom: -40px;
          left: 50%;
          margin-left: -20px;
          border: 20px solid transparent;
          border-top-color: #fcd54c;

          // 平板适配 - 缩小箭头
          //@media (max-width: 768px) {
          //  bottom: -20px;
          //  margin-left: -10px;
          //  border-width: 10px;
          //
          //}

          // 手机适配 - 隐藏箭头（避免布局错乱）
          @media (max-width: 480px) {
            bottom: -24px;
            margin-left: -12px;
            border-width: 12px;
          }
        }
      }

      // 第三个li的箭头装饰
      &:nth-of-type(3) div::before {
        position: absolute;
        content: '';
        top: -40px;
        left: 50%;
        margin-left: -20px;
        border: 20px solid transparent;
        border-bottom-color: #54a4cd;

        // 平板适配 - 缩小箭头
        @media (max-width: 768px) {
          top: -20px;
          margin-left: -10px;
          border-width: 10px;
        }

        // 手机适配 - 隐藏箭头
        @media (max-width: 480px) {
          top: -24px;
          margin-left: -12px;
          border-width: 12px;
        }
      }

      div a {
        width: 126px;
        height: 42px;
        margin-top: 30px;
        line-height: 42px;
        font-size: 16px;
        background: #d26b6b;
        color: #fff;
        border-radius: 5px;
        text-decoration: none; // 去除链接下划线
        display: inline-block; // 确保尺寸生效

        // 平板适配
        @media (max-width: 768px) {
          width: 100px;
          height: 36px;
          line-height: 36px;
          font-size: 14px;
          margin-top: 15px;
        }

        // 手机适配
        @media (max-width: 480px) {
          width: 80px;
          height: 30px;
          line-height: 30px;
          font-size: 12px;
          margin-top: 5px;
        }
      }
    }
  }
}
</style>